interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
  isLoading?: boolean | null; // Optional prop
  totalItems?: number;
}

const PaginationControls: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
  isLoading = false, // Defaults to false if not provided
  totalItems = 0,
}) => {
  const isFirstPage = currentPage === 1;
  const isLastPage = totalItems === 0 || currentPage === totalPages;

  const buttonBaseClass =
    "flex min-h-11 min-w-[72px] items-center justify-center rounded-lg px-3 py-2 text-sm font-medium transition-colors sm:min-w-[100px] sm:px-4 sm:text-base";
  const activeClass = "bg-[#0077C0] text-white hover:bg-[#005B90]";
  const disabledClass = "bg-gray-200 text-gray-500 cursor-not-allowed";

  return (
    <div className="flex flex-wrap items-center justify-center gap-2 p-3 sm:gap-3 sm:p-4">
      <button
        onClick={() => onPageChange(currentPage - 1)}
        disabled={isFirstPage || !!isLoading}
        className={`${buttonBaseClass} ${
          isFirstPage || isLoading ? disabledClass : activeClass
        }`}
      >
        {isLoading ? (
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
        ) : (
          "Previous"
        )}
      </button>

      <span className="flex items-center px-1 text-xs text-gray-700 sm:text-sm">
        Page {currentPage} of {totalPages}
      </span>

      <button
        onClick={() => onPageChange(currentPage + 1)}
        disabled={isLastPage || !!isLoading}
        className={`${buttonBaseClass} ${
          isLastPage || isLoading ? disabledClass : activeClass
        }`}
      >
        {isLoading ? (
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
        ) : (
          "Next"
        )}
      </button>
    </div>
  );
};

export default PaginationControls;
